import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { DataService } from "../../../services/data.service";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
declare var google;
@Component({
  selector: 'adf-address-detail',
  templateUrl: 'address-detail.html',
  providers: [DataService]
})
export class AddressDetail implements OnInit {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  @ViewChild(Slides) signupSlider: Slides;
  addreDetail: FormGroup;
  submitted = false;
  public applicant_details: any;
  public new_val: any;
  public old_val: any;
  public change_log_string: any;
  public showPrimaryApplicantAddress: number = 1;
  public showAdditional_address: number = -1;
  public indexx: number;
  formApplicant: FormArray;
  public multiple: any;
  public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  // public validation_messages = {
  //   primayr_goal_intention: ['', Validators.compose([Validators.required])],
  // }
  public address_format;
  public autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');
  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  })

  constructor(
    public formBuilder: FormBuilder,
    private DataService: DataService
  ) {
    this.applicant_details = '';

    this.addreDetail = formBuilder.group({
      address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      state: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      postcode: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.required])],
      country: ['Australia', Validators.compose([Validators.required])],
      housing_situation: ['', Validators.compose([Validators.required])],
      move_in_date: ['', Validators.compose([Validators.required])],
      addPreviousAddressItem: this.formBuilder.array([]),
      addAddressRelationshipItem: this.formBuilder.array([])
    });

    this.change_log_string = [];

  }
  // Validation 07-04-2021

  public validation_messages = {

    primayr_goal_intention: ['', Validators.compose([Validators.required])],
    'address_type': [
      { type: 'required', message: 'address type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'address_format': [
      { type: 'required', message: 'address format is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'street_type': [
      { type: 'required', message: 'street type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'housing_situation': [
      { type: 'required', message: 'Housing Situation is required.' }
    ],
    'street_number': [
      { type: 'required', message: 'street number is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'street_name': [
      { type: 'required', message: 'street name is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'city': [
      { type: 'required', message: 'city is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'state': [
      { type: 'required', message: 'state is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'postcode': [
      { type: 'required', message: 'postcode is required.' },
      { type: 'minLength', message: 'postcode must be at least 4 digit long' },
      { type: 'maxLength', message: 'postcode must be at least 4 digit long' }
    ],
    'move_in_date': [
      { type: 'required', message: 'move_in_date is required.' },
    ]
  }

  //previous_state

  public validation_messages_primary_previous = {
    'previous_address_type': [
      { type: 'required', message: 'address type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_address_format': [
      { type: 'required', message: 'address format is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_street_number': [
      { type: 'required', message: 'street number is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_housing_situation': [
      { type: 'required', message: 'Housing Situation is required.' }
    ],
    'previous_state': [
      { type: 'required', message: 'state is required.' },
    ],
    'previous_street_name': [
      { type: 'required', message: 'street name is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_street_type': [
      { type: 'required', message: 'street type is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_city': [
      { type: 'required', message: 'city is required.' },
      { type: 'maxLength', message: 'maxlength is 30' }
    ],
    'previous_postcode': [
      { type: 'required', message: 'postcode is required.' },
      { type: 'minLength', message: 'postcode must be at least 4 digit long' },
      { type: 'maxLength', message: 'postcode must be at least 4 digit long' }
    ],
    'previous_move_in_date': [
      { type: 'required', message: 'move in date is required.' },
    ],
    'previous_move_out_date': [
      { type: 'required', message: 'move out date is required.' },
    ]
  }


  //applicant address section
  get formArrApplicantAddress() {
    return this.addreDetail.get('addAddressRelationshipItem') as FormArray;
  }

  get f() { return this.addreDetail.controls; }
  get t() { return this.f.tickets as FormArray; }
  //applicant previous address section
  get formPreviousAddress() {
    return this.addreDetail.get('addPreviousAddressItem') as FormArray;
  }
  get formPrimaryAddress() {
    return this.addreDetail.get('addPreviousAddressItem') as FormArray;
  }

  addPreviousAddress(date) {
    this.formPreviousAddress.push(this.initaddPreviousAddress(date));
    this.indexx = this.formPreviousAddress.length - 1;
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }

  updatePreviousAddress(inputText, index, type){
    let addressInput = document.getElementById("address_"+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput,{
        componentRestrictions: { country: 'AU' }
    });
    autocomplete.inputId = addressInput;
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      let address_format = this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_address_format.value;
      let full_address = this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_full_address.value.split(' ');
      let full_address1 = full_address[0].split('/');
      if(full_address1.length == 1){
        full_address1 = full_address[0].split('-');
      }
      for (let i=0; i < place.address_components.length; i++){
        if (place.address_components[i].types[0] == "street_number") {
          if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
            this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          }else if(full_address1.length > 1){
            if(address_format == 'nonStandard'){
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            }else{
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(full_address[0]);
              this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_unit_number.setValue(full_address1[0]);
            }
          }else{
            this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_number.setValue(place.address_components[i].long_name);
          }
        }
        if (place.address_components[i].types[0] == "route") {
          let get_route = place.address_components[i].long_name;
          let type = place.address_components[i].long_name.split(" ");
          let typeName = type[type.length-1];
          let get_street_name = get_route.split(" "+typeName).join("");
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_name.setValue(get_street_name);
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_street_type.setValue(typeName.toUpperCase());
        }
        if (place.address_components[i].types[0] == "locality") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_city.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "administrative_area_level_1") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_state.setValue(place.address_components[i].short_name);
        }
        if (place.address_components[i].types[0] == "country") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_country.setValue(place.address_components[i].long_name);
        }
        if (place.address_components[i].types[0] == "postal_code") {
          this.addreDetail.controls['addPreviousAddressItem']['controls'][index].controls.previous_postcode.setValue(place.address_components[i].long_name);
        }
      }
      //this.signupSlider.update();
    });
  }



  initaddPreviousAddress(date) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      previous_address_type: ['Home', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: ['standard', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      previous_building_name: ['', Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      previous_street_number: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: ['', Validators.compose([Validators.maxLength(30),Validators.required])],
      previous_postcode: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: ['Australia', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_in_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [date, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }

  initItemApplicantAddress(index) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30)])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30)])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30)])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30)])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      index: index,
      addPAddressRelationshipItem: this.formBuilder.group({
        addPreviousAddressRelationshipItem: this.formBuilder.array([])
      })
    });
  }

  addAddressRelationship(index) {
    this.formArrApplicantAddress.push(this.initItemApplicantAddress(index));
    //console.log(this.addreDetail.controls.addAddressRelationshipItem);
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }
  addressOfApplicant(event, index) {
    this.showPrimaryApplicantAddress = 0;
    this.showAdditional_address = index;
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }
  primaryApplicantAddress(event) {
    debugger;
    this.showPrimaryApplicantAddress = 1;
    this.showAdditional_address = -1;
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }
  ngOnInit() {
    //this.signupSlider.autoHeight = true;

    // this.DataService.currentAddAnotherApplicant.subscribe(formApplicant => {
    //   //console.log(formApplicant);
    //   if(formApplicant) {

    //     this.formApplicant = formApplicant;
    //     this.addAddressRelationship(this.formApplicant.length)

    //   }
    // this.formApplicant.push(this.initaddAnotherApplicant());

    //});

    if (this.editdata.contact_details != undefined) {
      if(this.editdata.contact_details.address.length>0){
        var uData =this.editdata.contact_details.address[0];
        if(uData.address_format == '') {
          this.address_format='standard';
          this.addreDetail.controls.address_format.setValue('standard');
        }
        else {
          this.address_format=uData.address_format;
          this.addreDetail.controls.address_format.setValue(uData.address_format);
        }

        if(uData.address_type == '') {
          this.addreDetail.controls.address_type.setValue('Home');
        }
        else {
          this.addreDetail.controls.address_type.setValue(uData.address_type);
        }

        //this.addreDetail.controls.address_type.setValue(uData.address_type);

        this.addreDetail.controls.floor_number.setValue(uData.floor_number);
        //this.addreDetail.controls.full_address.setValue(uData.full_address);
        this.addreDetail.controls.unit_number.setValue(uData.unit_number);
        this.addreDetail.controls.building_name.setValue(uData.building_name);
        this.addreDetail.controls.poboxlabel.setValue(uData.poboxlabel);
        this.addreDetail.controls.street_number.setValue(uData.street_number);
        this.addreDetail.controls.street_name.setValue(uData.street_name);
        this.addreDetail.controls.street_type.setValue(uData.street_type);
        this.addreDetail.controls.city.setValue(uData.city);
        this.addreDetail.controls.state.setValue(uData.state);
        this.addreDetail.controls.postcode.setValue(uData.postcode);
        this.addreDetail.controls.country.setValue(uData.country);
        this.addreDetail.controls.housing_situation.setValue(uData.housing_situation);
        this.addreDetail.controls.move_in_date.setValue(uData.move_in_date);
        this.applicant_details = uData;
      }
      for(var i=0;i<this.editdata.contact_details.address.length;i++){
        if(this.editdata.contact_details.address[i].type=='previous'){
          console.log(this.editdata.contact_details.address[i])
            if(this.editdata.contact_details.address[i].address_format=='standard') {

              this.editdata.contact_details.address[i].floor_number = '';
            }
          this.formPreviousAddress.push(this.initaddPreviousAddressLoad(this.editdata.contact_details.address[i]));
        }
      }


    }
    else {
      this.address_format = 'standard';
    }
  }

  ngAfterViewInit(){
    this.getPlaceAutocomplete();
  }

  getPlaceAutocomplete(){
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
    {
        componentRestrictions: { country: 'AU' }
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        let address_format = this.addreDetail.controls.address_format.value;
        let full_address = this.addreDetail.controls.full_address.value.split(' ');
        let full_address1 = full_address[0].split('/');
        if(full_address1.length == 1){
          full_address1 = full_address[0].split('-');
        }
        for (let i=0; i < place.address_components.length; i++){

          this.new_val = '';
          this.old_val = '';

          if (place.address_components[i].types[0] == "street_number") {
            if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
              this.addreDetail.controls.street_number.setValue(place.address_components[i].long_name);
            }else if(full_address1.length > 1){
              if(address_format == 'nonStandard'){
                this.addreDetail.controls.street_number.setValue(full_address[0]);
                this.addreDetail.controls.unit_number.setValue(full_address1[0]);
              }else{
                this.addreDetail.controls.street_number.setValue(full_address[0]);
                this.addreDetail.controls.unit_number.setValue(full_address1[0]);
              }
            }else{
              this.addreDetail.controls.street_number.setValue(place.address_components[i].long_name);
            }

            this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
            this.new_val = place.address_components[i].long_name;

            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_number='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Number', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "route") {
            let get_route = place.address_components[i].long_name;
            let type = place.address_components[i].long_name.split(" ");
            let typeName = type[type.length-1];
            let get_street_name = get_route.split(" "+typeName).join("");
            this.addreDetail.controls.street_name.setValue(get_street_name);
            this.addreDetail.controls.street_type.setValue(typeName.toUpperCase());

            this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
            this.new_val = get_street_name;
            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_name='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Name', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }

            this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
            this.new_val = typeName.toUpperCase();
            if(this.new_val != this.old_val){
              //this.change_log_string += 'street_type='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Street Type', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }

          }
          if (place.address_components[i].types[0] == "locality") {
            this.addreDetail.controls.city.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
            this.new_val = place.address_components[i].long_name;

            if(this.new_val != this.old_val){
              //this.change_log_string += 'city='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'City', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            this.addreDetail.controls.state.setValue(place.address_components[i].short_name);
            this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
            this.new_val = place.address_components[i].short_name;

            if(this.new_val != this.old_val){
              //this.change_log_string += 'state='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'State', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "country") {
            this.addreDetail.controls.country.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
            this.new_val = place.address_components[i].long_name;

            if(this.new_val != this.old_val){
              //this.change_log_string += 'country='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Country', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
          if (place.address_components[i].types[0] == "postal_code") {
            this.addreDetail.controls.postcode.setValue(place.address_components[i].long_name);
            this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
            this.new_val = place.address_components[i].long_name;

            if(this.new_val != this.old_val){
              //this.change_log_string += 'postcode='+this.old_val+':'+this.new_val+';';
              this.change_log_string.push({'property' : 'Postcode', 'old_value' : this.old_val, 'new_value' : this.new_val});
            }
          }
        }
        //this.signupSlider.update();
    });
  }

  initaddPreviousAddressLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      previous_address_type: [data.address_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_address_format: [data.address_format, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_full_address: [''],
      previous_floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      previous_unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      previous_building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      previous_poboxlabel: [data.poboxlabel, Validators.compose([Validators.maxLength(30)])],
      previous_street_number: [data.street_number, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_name: [data.street_name, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_street_type: [data.street_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_city: [data.city, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_state: [data.state, Validators.compose([Validators.maxLength(30),Validators.required])],
      previous_postcode: [data.postcode, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_country: [data.country, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_housing_situation: [data.housing_situation, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_in_date: [data.move_in_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      previous_move_out_date: [data.move_out_date, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }
  ngOnChanges() {
    console.log('abc', this.editdata); // object here

    // if (this.editdata.contact_details != undefined) {
    //   if(this.editdata.contact_details.address.length>0){
    //     var uData =this.editdata.contact_details.address[0];
    //     if(uData.address_format == '') {
    //       this.address_format='standard';
    //       this.addreDetail.controls.address_format.setValue('standard');
    //     }
    //     else {
    //       this.address_format=uData.address_format;
    //       this.addreDetail.controls.address_format.setValue(uData.address_format);
    //     }

    //     if(uData.address_type == '') {
    //       this.addreDetail.controls.address_type.setValue('Home');
    //     }
    //     else {
    //       this.addreDetail.controls.address_type.setValue(uData.address_type);
    //     }

    //     //this.addreDetail.controls.address_type.setValue(uData.address_type);

    //     this.addreDetail.controls.floor_number.setValue(uData.floor_number);
    //     //this.addreDetail.controls.full_address.setValue(uData.full_address);
    //     this.addreDetail.controls.unit_number.setValue(uData.unit_number);
    //     this.addreDetail.controls.building_name.setValue(uData.building_name);
    //     this.addreDetail.controls.poboxlabel.setValue(uData.poboxlabel);
    //     this.addreDetail.controls.street_number.setValue(uData.street_number);
    //     this.addreDetail.controls.street_name.setValue(uData.street_name);
    //     this.addreDetail.controls.street_type.setValue(uData.street_type);
    //     this.addreDetail.controls.city.setValue(uData.city);
    //     this.addreDetail.controls.state.setValue(uData.state);
    //     this.addreDetail.controls.postcode.setValue(uData.postcode);
    //     this.addreDetail.controls.country.setValue(uData.country);
    //     this.addreDetail.controls.housing_situation.setValue(uData.housing_situation);
    //     this.addreDetail.controls.move_in_date.setValue(uData.move_in_date);
    //     this.applicant_details = uData;
    //   }
    //   for(var i=0;i<this.editdata.contact_details.address.length;i++){
    //     if(this.editdata.contact_details.address[i].type=='previous'){
    //       console.log(this.editdata.contact_details.address[i])
    //       this.formPreviousAddress.push(this.initaddPreviousAddressLoad(this.editdata.contact_details.address[i]));
    //     }
    //   }


    // }
    // else {
    //   this.address_format = 'standard';
    // }


  }


  public changeAddressFormat($event, index, types) {
    debugger;
    let streetNumber = this.addreDetail.get('street_number');
    let streetName = this.addreDetail.get('street_name');
    let streetType = this.addreDetail.get('street_type');
    if (types == 'primary_address') {
      this.address_format = $event;
      streetNumber = this.addreDetail.get('street_number');
      streetName = this.addreDetail.get('street_name');
      streetType = this.addreDetail.get('street_type');
    } else if (types == 'primary_previous') {
      streetNumber = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_number');
      streetName = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_name');
      streetType = this.addreDetail.controls.addPreviousAddressItem['controls'][index].get('previous_street_type');
    } else if (types == 'secondary_address') {
      streetNumber = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_number');
      streetName = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_name');
      streetType = this.addreDetail.controls.addAddressRelationshipItem['controls'][index].get('addi_street_type');
    }
    if ($event == 'nonStandard') {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    } else if ($event == 'poBox') {
      streetNumber.setValidators(null);
      streetName.setValidators(null);
      streetType.setValidators(null);
    } else {
      streetNumber.setValidators(Validators.required);
      streetName.setValidators(Validators.required);
      streetType.setValidators(Validators.required);
    }
    streetNumber.updateValueAndValidity();
    streetName.updateValueAndValidity();
    streetType.updateValueAndValidity();
    //this.signupSlider.resize();
    //this.signupSlider.update();

    this.new_val = event;
    this.old_val = '';
    var property = '';
    // if(types == 'address_format'){
    //   if(this.allRealEstatess.length > index){
    //     this.old_val = this.allRealEstatess[index].address_format;
    //   }else{
    //     this.old_val = '';
    //   }
    //   if(this.old_val == undefined){
    //     this.old_val = '';
    //   }
    //   property = 'Address Format';
    // }
    // if(this.new_val != this.old_val && property != ""){
    //   this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index});
    // }
    // this.realEstate_details.sort((a,b)=>a.index > b.index);

  }

  initItemRowsPreviousAddress(getdate) {

    return this.formBuilder.group({
      addi_same_as_primary: ['true'],
      addi_address_type: ['Home', Validators.compose([Validators.maxLength(30)])],
      addi_address_format: ['standard', Validators.compose([Validators.maxLength(30)])],
      addi_full_address: ['', Validators.compose([Validators.maxLength(30)])],
      addi_floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_building_name: ['', Validators.compose([Validators.maxLength(200)])],
      addi_street_number: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_name: ['', Validators.compose([Validators.maxLength(30)])],
      addi_street_type: ['', Validators.compose([Validators.maxLength(30)])],
      addi_poboxlabel: ['', Validators.compose([Validators.maxLength(30)])],
      addi_city: ['', Validators.compose([Validators.maxLength(30)])],
      addi_state: ['', Validators.compose([Validators.maxLength(30)])],
      addi_postcode: ['', Validators.compose([Validators.maxLength(30)])],
      addi_country: ['Australia', Validators.compose([Validators.maxLength(30)])],
      addi_housing_situation: ['', Validators.compose([Validators.maxLength(30)])],
      addi_move_out_date: [getdate, Validators.compose([Validators.maxLength(30)])],
      addi_move_in_date: ['', Validators.compose([Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0]
    });
  }

  changeLog(event, index: any) {
    console.log(event);
  }

  collectLogData(event, type, index) {

    this.new_val = event.target.value;
    debugger;
    this.old_val = '';
    var property = '';

    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }

    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  removePreviousAddress(key) {
    if (key > -1) {
      for (var i = this.formPreviousAddress.length; i > 0; i--) {
        if (i > key) {
          this.formPreviousAddress.removeAt(i);
        }
      }
    } else {
      this.formPreviousAddress.removeAt(key);
    }
    //this.signupSlider.resize();
    //this.signupSlider.update();
  }
  removePreviousAddressRelationship1(key) {
    if (key > -1) {
      for (var i = this.formPreviousAddress.length; i > 0; i--) {
        if (i > key) {
          this.formPreviousAddress.removeAt(i);
        }
      }
    } else {
      this.formPreviousAddress.removeAt(key);
    }
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }

  getCurrentAddressDate(event, key, con_type, index) {
    var getDate = event.target.value;
    var datesplit = getDate.split("/");
    if (datesplit.length == 3) {
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2] + '-' + datesplit[1] + '-' + datesplit[0] + 'T00:00:00Z')
      oldDate.setMonth(oldDate.getMonth() + 36);
      var oldDate1 = oldDate.getTime();
      debugger
      if (con_type == 'primary') {
        if (newDate > oldDate1) {
          this.removePreviousAddress(key)
        } else {
          if ((this.formPreviousAddress.length == 1 && key == "main")) {
          } else {
            if (this.formPreviousAddress.length == (key + 1)) {
              let date = this.addreDetail.controls.addPreviousAddressItem.value[key].previous_move_in_date;
              this.addPreviousAddress(date)
            } else if ((this.formPreviousAddress.length == 0 && key == "main")) {
              let date = this.addreDetail.controls.move_in_date.value;
              this.addPreviousAddress(date);
            }
          }
        }
      } else if (con_type == 'additional') {
        // if(newDate > oldDate1){
        //   this.removePreviousAddressRelationship1(key)
        // }else{
        //   if((this.formPreviousAddress.length == 1 && key == "main")){
        //   }else{
        //     if(this.formPreviousAddress.length == (key+1)){
        //       this.addPreviousAddressRelationship1(index)
        //     }else if((this.formPreviousAddress.length == 0 && key == "main")){
        //       this.addPreviousAddressRelationship1(index)
        //     }
        //   }
        // }
      }
    }
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }
  addPreviousAddressRelationship1(index, getDate) {
    //alert('adding form');
    debugger;
    //c//onsole.log(this.addreDetail);
    //console.log(this.slideOneForm.controls.addAddressRelationshipItem['controls'].addPAddressRelationshipItem.controls.addPreviousAddressRelationshipItem.controls);
    this.formArrApplicantAddress.controls[index]['controls']['addPAddressRelationshipItem'].controls['addPreviousAddressRelationshipItem'].push(this.initItemRowsPreviousAddress(getDate));
    //this.formPreviousAddress.push(this.initaddPreviousAddress(getDate));
    //console.log(this.slideOneForm);
    this.indexx = this.formPreviousAddress.length - 1;
    // this.signupSlider.resize();
    // this.signupSlider.update();
  }

  codeInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  getValue() {
    //this.additionalForm.get
    console.log(this.addreDetail.value);
    //console.log(this.formArrApplicantAddress.controls.city.value;
    this.valueChange.emit(this.addreDetail.value);

  }



}


// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/component/primary-applicant/address-detail/address-detail.ts